// src/pages/Resume.jsx
import styled from "styled-components";

const Resume = () => {
  return (
    <Wrapper>
      <h1>Resume</h1>
      <div className="underline" />
      <p>
        <a
          href="https://drive.google.com/file/d/1fA8zXlzOtUXqL3gB4C8puVAmDkdm2Tjc/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click Here To Open Resume
        </a>
      </p>
    </Wrapper>
  );
};

export default Resume;

const Wrapper = styled.div`
  color: ${({ theme }) => theme.text};
  padding: 2em 0em;

  @media (max-width: 768px) {
   padding: 6rem 2rem 3rem 2rem;
  }

  h1 {
    font-size: 2rem;
    font-weight: 700;
  }

  .underline {
    width: 50px;
    height: 4px;
    background-color: ${({ theme }) => theme.accent};
    margin: 10px 0 25px;
    border-radius: 5px;
  }

  a {
    font-size: 1.2rem;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
    text-decoration: none;
    transition: 0.3s;

    &:hover {
      color: ${({ theme }) => theme.accent};
    }
  }
`;

